import { jsx as _jsx } from "react/jsx-runtime";
import { TrackingPropsContext } from './tracking-props-context';
export const TrackingPropsContextWrapper = ({ backendTrackingMetaData, children, entryPoint, inputHintClick, interactionTargetUrn, propChannel, propSocialInteractionId, propSourceType, }) => (_jsx(TrackingPropsContext.Provider, { value: {
        backendTrackingMetaData,
        entryPoint,
        inputHintClick,
        interactionTargetUrn,
        propChannel,
        propSocialInteractionId,
        propSourceType,
    }, children: children }));
//# sourceMappingURL=tracking-props-context-wrapper.js.map